import { apiClient } from "../api/api-client";
import { getAttendanceQueue, removeFromAttendanceQueue } from "../utils/attendanceStorage";

const isOnline = () => navigator.onLine;

let isProcessing = false;

const processQueue = async () => {
  if (!isOnline() || isProcessing) return;

  const queue = getAttendanceQueue();
  if (queue.length === 0) return;

  isProcessing = true;

  try {
    for (let i = queue.length - 1; i >= 0; i--) {
      const item = queue[i];
      try {
        await apiClient({
          url: `booking/worker/attendance/${item.bookingRequestSlug}`,
          method: "POST",
          data: {
            workerSlug: item.workerSlug,
            time: item.time,
            lat: item.lat,
            lng: item.lng,
          },
        });
        removeFromAttendanceQueue(i);
      } catch (error) {
        console.error("Failed to sync attendance:", error);
      }
    }
  } finally {
    isProcessing = false;
  }
};

export const initAttendanceQueue = () => {
  processQueue();
  window.addEventListener("online", processQueue);
  setInterval(processQueue, 30000);
};
